"use client"
import { createContext, useContext } from "react"
import { useI18n } from "@/i18n/client"
import type { WizardProblem } from "./wizard-validation"
export const WizardValidationContext = createContext<WizardProblem | null>(null)
export function useWizardFieldError(field: string) {
  const issue = useContext(WizardValidationContext)
  const { t } = useI18n()
  return issue?.field === field ? t(issue.message) : ""
}

